<!-- This is a wrapper around the blob manager for employee skill uploads, I needed only a couple extra fields but did not want to mix them 
        in with the blob manager since they are not needed for all uploads -->
<app-blob-manager [angularUpload]="true" [containerName]="'employee-skill'" [uploadLabel]="'Doc'" [viewOnly]="viewOnly" [parentRecordId]="employeeSkill.id"></app-blob-manager>
